// extracted by mini-css-extract-plugin
export default {"canvas":"ParticleField_canvas__DHjV+"};